module.exports = __webpack_public_path__ + "img/program_img3.6a6232e4.png";